export default __webpack_public_path__ + "static/12-7e9cb7673331089477e6381bc94092ba.png";